import { Spinner } from '../shared/Spinner';

export const AppLoader = () => (
  <div className="absolute w-full h-full flex justify-center items-center top-0 left-0">
    <Spinner variant="appLoading" />
  </div>
);
